/* @flow */

import { combineReducers } from 'redux';

import topicsFetchingReducer from 'src/shared/app/account/topic/reducer/topicsFetchingReducer';
import appTopicBookableReducer from 'src/shared/app/topic/browse/reducer/appTopicBookableReducer';
import { createFilteredReducer } from 'src/shared/core/util/reducerUtils';
import * as namespaces from 'src/shared/domain/topic/action/topicActionNamespaces';
import topicsUsersFetchingReducer from 'src/shared/app/account/topic/reducer/topicsUsersFetchingReducer';

// $FlowIssue
const appTopicsReducer = combineReducers({
  bookable: appTopicBookableReducer,
  own: createFilteredReducer(
    topicsFetchingReducer,
    (action) => action.namespace === namespaces.OWN_TOPICS,
  ),
  ownActive: createFilteredReducer(
    topicsFetchingReducer,
    (action) => action.namespace === namespaces.OWN_ACTIVE_TOPICS,
  ),
  ownHidden: createFilteredReducer(
    topicsFetchingReducer,
    (action) => action.namespace === namespaces.OWN_HIDDEN_TOPICS,
  ),
  ownPending: createFilteredReducer(
    topicsFetchingReducer,
    (action) => action.namespace === namespaces.OWN_PENDING_TOPICS,
  ),
  ownRejected: createFilteredReducer(
    topicsFetchingReducer,
    (action) => action.namespace === namespaces.OWN_REJECTED_TOPICS,
  ),
  user: createFilteredReducer(
    topicsFetchingReducer,
    (action) => action.namespace === namespaces.USER_TOPICS,
  ),
  users: createFilteredReducer(
    topicsUsersFetchingReducer,
    (action) => action.namespace === namespaces.USERS_TOPICS,
  ),
});

export default appTopicsReducer;
